import { render, staticRenderFns } from "./myHomework.vue?vue&type=template&id=98db3ccc"
import script from "./myHomework.vue?vue&type=script&lang=js"
export * from "./myHomework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports